import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    num: "01",
    title: "Full Refurbishments",
    desc: "Complete home transformations managed end to end — one team, every trade, from first strip-out to the final coat of paint.",
  },
  {
    num: "02",
    title: "Painting & Decorating",
    desc: "Internal and external decorating done properly: meticulous preparation, premium paints, crisp lines and hand-finished detail.",
  },
  {
    num: "03",
    title: "Bathroom Installations",
    desc: "Full bathroom installations from rip-out to finish — tiling, suites, lighting, ventilation and plumbing, all finished with care.",
  },
  {
    num: "04",
    title: "Kitchen Installations",
    desc: "Kitchens designed, supplied and installed around how you actually cook, live and gather — units, worktops, flooring and all.",
  },
  {
    num: "05",
    title: "End of Tenancy Cleaning",
    desc: "Deep, deposit-safe end of tenancy cleaning for tenants and landlords — checklists matched to your inventory, top to bottom.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#121212]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-20">
          <Reveal>
            <Eyebrow className="mb-4">What we do</Eyebrow>
            <h2 className="font-serif text-4xl md:text-6xl text-[#f5f5f0] leading-tight">
              Every trade,
              <br />
              <em className="italic text-[#c5832b]">under one roof.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-[#a3a3a3] leading-relaxed">
              One point of contact for the whole job — no chasing builders,
              no matching quotes, no gaps between trades.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-white/10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.06}>
              <button
                data-testid={`service-row-${s.num}`}
                onClick={() => scrollToId("quote")}
                className="group relative w-full text-left border-b border-white/10 py-8 md:py-10 flex items-center gap-6 md:gap-12 transition-colors duration-500 hover:bg-white/[0.03] px-2 md:px-6"
              >
                <span className="text-xs md:text-sm text-[#c5832b] font-semibold tracking-widest w-8 shrink-0">
                  {s.num}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block font-serif text-2xl md:text-4xl text-[#f5f5f0] group-hover:text-[#d9953c] transition-colors duration-300">
                    {s.title}
                  </span>
                  <span className="block mt-2 md:mt-3 text-sm md:text-base text-[#a3a3a3] max-w-2xl leading-relaxed">
                    {s.desc}
                  </span>
                </span>

                <span className="shrink-0 w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-[#a3a3a3] group-hover:bg-[#c5832b] group-hover:border-[#c5832b] group-hover:text-[#121212] transition-colors duration-300">
                  <ArrowUpRight size={18} />
                </span>
              </button>
            </Reveal>
          ))}
        </div>

        <p className="mt-8 text-xs text-[#a3a3a3]/70 hidden md:block">
          Click a service to request a quote.
        </p>
      </div>
    </section>
  );
}
